<div class="row">
  <div class="col-md-12 nopad">
    <div class="card shadow-lg rounded-lg border-0">

      <!-- Header -->
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <h3 class="mb-0">📊 Sales Report</h3>
       
      </div>

      <!-- Filters -->
      <div class="card-body filter-section">
        <div class="row g-3">
<!-- <div class="col-sm-6 col-md-2">
          <label>Store Name</label>
            <select class="form-select form-select-sm" [(ngModel)]="selectedStore">
              <option value="" disabled>Select Store</option>
              <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
            </select>
</div> -->
          <div class="col-sm-6 col-md-2">
            
            <label>From</label>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="From" />
          </div>

          <div class="col-sm-6 col-md-2">
            <label>To</label>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="To" />
          </div>

          <div class="col-sm-6 col-md-2 d-flex align-items-end">
            <button (click)="display()" class="btn btn-success w-100">
              <i class="fas fa-eye me-1"></i> Show
            </button>
          </div>

          <div class="col-sm-6 col-md-2 d-flex align-items-end">
            <button (click)="export_excel()" class="btn btn-info w-100">
              <i class="fas fa-file-excel me-1"></i> Excel
            </button>
          </div>

<div class="col-sm-6 col-md-2 d-flex align-items-end align-items-center">
  <div class="fw-bold ms-2" style="color: rgb(219, 45, 74);">
    Total Amount: {{ totalAmount | number:'1.2-2' }}
  </div>
          <!-- <div class="col-sm-6 col-md-2 d-flex align-items-end">
            <button (click)="export_pdf()" class="btn btn-danger w-100">
              <i class="fas fa-file-pdf me-1"></i> PDF
            </button>
          </div> -->
        </div>
      </div>

      <!-- Table -->
      <div class="card-body">
        <div  class="text-center my-3">
          <!-- <div class="spinner-border text-primary"></div> -->
        </div>

        <div class="table-responsive">
  <table class="table table-hover table-striped align-middle">
    <thead class="table-primary">
      <tr>
        <th>#</th>
        
        <th>Product Name</th>
        <th>Bill No</th> 
        <th>Quantity</th>
        <th> Price</th>
         <th> Total</th>
        <th> Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of SummaryReport_Row; let i = index">
        <td>{{ i + 1 }}</td>
       
        <!-- <td>{{ row.Item Name }}</td>
        <td>{{ row.Unit Rate }}</td>
        
        <td>{{ row.Barcode }}</td>
        <td>{{ row.Phone No }}</td> -->


        <td>{{ row['Product Name'] }}</td>
<td>{{ row['Billno'] }}</td> 
<td>{{ row['Qty'] }}</td>
       <td>{{ row['Price'] }}</td>
<td>{{ row['Total'] }}</td>
<td>{{ row['Date'] }}</td>

        
      </tr>
    </tbody>
  </table>


        </div>
      </div>
    </div>
  </div>
</div>
